import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        $( '.marquee__splide' ).each( function( index, element ) {
          console.log( element );
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: $( element ).hasClass( 'forward' ) ? .75 : -.75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
